package com.devi3east.bashbuddy.auth.navigation

import androidx.navigation.NavGraphBuilder
import androidx.navigation.compose.composable
import com.devi3east.bashbuddy.auth.ui.SignInScreenRoute
import com.devi3east.bashbuddy.features.app.data.AppState
import com.devi3east.bashbuddy.features.app.data.Screen

fun NavGraphBuilder.signInNavGraph(
    appState: AppState
) {
    composable(Screen.SignInScreen.route) {
        SignInScreenRoute(
            appState = appState
        )
    }
}